<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-09-05 15:36:55
 * @Description: 当月运营数据
 -->

<template>
  <div class="m-operation-data-wrapper">
    <div class="cur-data-wrapper">
      <img src="https://files.jinr.com/jinr-index/data-report/cur-data-01.jpg" alt="" srcset="" />
      <img src="https://files.jinr.com/jinr-index/data-report/cur-data-02.jpg" alt="" srcset="" />
      <img
        class="risk-management"
        src="https://files.jinr.com/jinr-index/data-report/cur-data-03.jpg"
        alt=""
        srcset=""
      />
      <img
        class="img-title"
        src="https://files.jinr.com/jinr-index/data-report/cur-data-04.png"
        alt=""
        srcset=""
      />
    </div>
    <div class="more clearfix">
      <a
        :href="
          `https://jinrfe.jinr.com/JydReport/index.html#/report?years=${currentData.year}&month=${
            item.month < 10 ? `0${item.month}` : item.month
          }`
        "
        v-for="(item, index) in currentData.list"
        :key="index"
        class="data-item"
      >
        <img src="https://files.jinr.com/jinr-index/img/data-report.png" alt="" srcset="" />
        <p class="year">{{ currentData.year }}</p>
        <p class="month">第{{ item.month }}月份</p>
        <p class="text">运营报告</p>
      </a>
    </div>
    <div class="check-more">
      <router-link class="btn" to="m-total">查看更多</router-link>
    </div>
  </div>
</template>
<script>
import dataList from './map.js';
export default {
  name: 'operation-data',
  computed: {
    currentData() {
      const tmp = dataList[0];
      return tmp;
    }
  }
};
</script>
<style lang="less" scope>
.m-operation-data-wrapper {
  background: #f2f2f2;
  .cur-data-wrapper {
    text-align: center;
    img {
      width: 100%;
    }
    .risk-management {
      margin: 0.3rem 0;
    }
    .img-title {
      // width: 560px;
      width: 90%;
      margin: 0 auto;
    }
  }
  .more {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .data-item {
      position: relative;
      width: 2.8rem;
      height: 1.52rem;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // height: 1.34rem;
      margin: 0 0.05rem;
      color: #fff;
      img {
        position: absolute;
        z-index: 0;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      .year {
        position: relative;
        width: 100%;
        z-index: 1;
        font-size: 0.26rem;
        font-weight: 600;
        text-align: center;
      }
      .month {
        position: relative;
        z-index: 1;
        padding: 0px 0.1rem;
        background: #fff;
        color: #247af1;
        border-radius: 0.1rem;
        font-size: 0.24rem;
        text-align: center;
      }
      .text {
        position: relative;
        z-index: 1;
        font-size: 0.26rem;
      }
    }
  }
  .check-more {
    padding: 0.4rem 0;
    background: #fff;
    .btn {
      display: block;
      width: 1.4rem;
      text-align: center;
      margin: 0 auto;
      font-size: 0.26rem;
      border: 0.02rem solid #666;
      color: #666;
    }
  }
}
</style>
